<script lang="ts">
  import BaseLayout from "./BaseLayout.svelte";

  export let title = "";
</script>

<BaseLayout>
  <div class="form">
    <div class="subtitle">
      {title}
    </div>

    <hr class="hr" />

    <slot />
  </div>
</BaseLayout>

<style>
  .form {
    flex-direction: column;
    max-width: 400px;
    margin: auto;
    margin-top: 5rem;
    width: 100%;
  }

  .subtitle {
    text-align: center;
    margin-top: 40px;
    font-size: 20px;
  }

  .hr {
    border: 0;
    border-top: 1px solid #eee;
    margin: 20px 0;
  }
</style>
